import { useState } from 'react';
import { C, FONTS } from '../../tokens/design';

export default function Button({ children, variant = 'sec', onClick, style = {}, disabled = false, type = 'button', title }) {
  const [hovered, setHovered] = useState(false);
  const [pressed, setPressed] = useState(false);
  const VARIANTS = {
    pri:   { bg: 'var(--color-secondary, ' + C.red + ')', c: '#fff', br: '1px solid rgba(255,255,255,0.08)', shadow: '0 10px 22px rgba(233,69,96,0.18)' },
    sec:   { bg: C.s2, c: C.t1, br: `1px solid ${C.b1}`, shadow: '0 8px 18px rgba(0,0,0,0.12)' },
    ghost: { bg: 'transparent', c: C.sky, br: '1px solid transparent', shadow: 'none' },
  };
  const v = VARIANTS[variant] || VARIANTS.sec;
  return (
    <button
      type={type}
      title={title}
      disabled={disabled}
      onClick={disabled ? undefined : onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => { setHovered(false); setPressed(false); }}
      onMouseDown={() => setPressed(true)}
      onMouseUp={() => setPressed(false)}
      style={{
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6,
      minHeight: 30, padding: '6px 12px', borderRadius: 6, cursor: disabled ? 'not-allowed' : 'pointer',
      fontSize: 12, fontWeight: 600, fontFamily: FONTS.sans,
      background: v.bg, color: v.c, border: v.br, opacity: disabled ? 0.55 : 1,
      boxShadow: !disabled && hovered ? v.shadow : 'none',
      transform: !disabled && pressed ? 'translateY(1px)' : 'translateY(0)',
      transition: 'background 0.14s ease, border-color 0.14s ease, box-shadow 0.14s ease, transform 0.08s ease, opacity 0.14s ease',
      whiteSpace: 'nowrap',
      ...style,
    }}>{children}</button>
  );
}
